<script lang="ts">
  import { onMount } from "svelte";
  import { getMe, logout, setUnauthorizedHandler } from "./api";
  import { currentUser } from "./stores";
  import Login from "./Login.svelte";
  import Grid from "./Grid.svelte";
  import AdminPanel from "./AdminPanel.svelte";
  import ChangePassword from "./ChangePassword.svelte";

  let checked = false;
  let showAdmin = false;
  let showChangePw = false;

  onMount(async () => {
    setUnauthorizedHandler(() => currentUser.set(null));
    try { currentUser.set(await getMe()); } catch { currentUser.set(null); }
    checked = true;
  });

  async function doLogout(): Promise<void> {
    await logout();
    currentUser.set(null);
    showAdmin = false;
  }
</script>

{#if !checked}
  <div class="splash">Loading…</div>
{:else if !$currentUser}
  <Login />
{:else if $currentUser.must_change_password}
  <!-- Forced: the server blocks all protected endpoints until this is done. -->
  <ChangePassword
    forced
    on:done={() => getMe().then((u) => currentUser.set(u))}
  />
{:else}
  <div class="app-shell">
    <header class="topbar">
      <strong class="brand">Karlsruhe Cameras</strong>
      <span class="spacer"></span>
      <span class="who">{$currentUser.username}{$currentUser.is_admin ? " (admin)" : ""}</span>
      {#if $currentUser.is_admin}
        <button on:click={() => (showAdmin = true)}>Admin</button>
      {/if}
      <button on:click={() => (showChangePw = true)}>Change password</button>
      <button on:click={doLogout}>Log out</button>
    </header>

    <main class="content">
      <Grid />
    </main>
  </div>

  {#if showAdmin}
    <AdminPanel on:close={() => (showAdmin = false)} />
  {/if}
  {#if showChangePw}
    <ChangePassword
      on:close={() => (showChangePw = false)}
      on:done={() => { showChangePw = false; getMe().then((u) => currentUser.set(u)); }}
    />
  {/if}
{/if}
